import { showOnBoardingDelete } from '@cian/favorites-assign-widget';
import { deleteFromFavorite as _deleteFromFavorite } from '../../services/deleteFromFavorite';
import { TThunkAction } from '../../types/redux/thunk';
import { updateFavorite } from '../promoOffers';

export const deleteFromFavorite =
  (offerId: number): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    try {
      await _deleteFromFavorite(context, { offerId });
      dispatch(updateFavorite({ offerId, isFavorite: false }));
      dispatch(showOnBoardingDelete());
    } catch (error) {
      context.logger.error(error, {
        offerId,
        domain: 'deleteFromFavorite',
      });
    }
  };
